<template>
  <transition :name="transitionName">
    <div v-if="active" class="con-tab vs-tabs--content"><slot /></div>
  </transition>
</template>

<script>
let nextTabId = 0;

export default {
  name: "VsTab",
  inheritAttrs: false,
  inject: ["vsTabs"],
  props: {
    label: {
      type: String,
      default: "Label",
    },
    icon: {
      type: String,
      default: "",
    },
    tag: {
      type: String,
      default: "",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
  },
  data() {
    return {
      tabId: nextTabId++,
      vertical: false,
      active: false,
      invert: false,
    };
  },
  computed: {
    transitionName() {
      if (this.invert) {
        return this.vertical ? "fade-tab-vertical-invert" : "fade-tab-invert";
      }
      return this.vertical ? "fade-tab-vertical" : "fade-tab";
    },
  },
  created() {
    this.vsTabs.registerTab(this);
  },
  beforeUnmount() {
    this.vsTabs.unregisterTab(this);
  },
};
</script>
